import type { SelectRootProps } from '@base-ui/react';

import { Select as BaseSelect } from '@base-ui/react';

type Props<Value, Multiple extends boolean | undefined = false> = SelectRootProps<Value, Multiple>;

export const SelectRoot = <Value, Multiple extends boolean | undefined = false>({ ...delegated }: Props<Value, Multiple>) => {
  return <BaseSelect.Root {...delegated} modal={delegated.modal ?? false} />;
};
